<template>
  <v-row no-gutters justify-md="center">
    <v-col cols="12" md="9">
      <v-row>
        <v-col cols="12" class="text-center mt-md-8 mb-2 mb-md-11">
          <h2>
            Refer A Friend and Earn up to $100 Per Referral
          </h2>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters justify="center">
            <v-col cols="12" md="8">
              <v-img src="/static/img/amui/enroll-greengeeks-affiliate-program.png"></v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <p class="mb-0 text-justify">
            The GreenGeeks web hosting affiliate program is one of the most rewarding & highest
            paying affiliate programs available on the Internet today. Join over 20,000 affiliates
            and help promote one of the fastest growing web hosting brands on the Internet.
            Not only will you be promoting a great web hosting service, but you'll also be
            spreading our green message to help make the Internet a greener medium.
          </p>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" md="6">
              <ul class="list-unstyled">
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Free to Join
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Dedicated Affiliate Team
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Wide Selection of Creatives, Content & Banners
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Unique Affiliate Tracking URL
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Targeted Landing Pages
                </li>
              </ul>
            </v-col>
            <v-col cols="12" md="6">
              <ul class="list-unstyled">
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Custom Campaign Tracking
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Advanced Real-time Statistics
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  Competitive Commissions for Performers
                </li>
                <li>
                  <v-icon color="primary" size="20">mdi-check-circle</v-icon>
                  and much, much more.
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col cols="12" sm="8" md="5" lg="4">
          <div class="justify-center">
            <gg-select
              outlined
              label="What Best Describes You"
              v-model="model.describes"
              v-validate="rules.describes"
              :items="items"
              data-vv-name="describes"
              data-vv-as="What Best Describes You"
              :error-messages="errors.collect('describes')"
            ></gg-select>
          </div>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col cols="12" sm="8" md="5" lg="4">
          <div>
            <gg-text-field
              v-model="model.paypal_address"
              label="Payment Method: PayPal"
              placeholder="Enter Your PayPal Email Address"
              v-validate="rules.paypal_address"
              data-vv-name="paypal_address"
              data-vv-as="PayPal Address"
              :error-messages="errors.collect('paypal_address')"
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-checkbox
              v-model="agreement"
              data-vv-name="Agreement"
              data-vv-as="Agreement"
              v-validate="'required:true'"
              :error-messages="errors.collect('Agreement')"
              color="primary"
              class="mt-0"
            >
              <template v-slot:label>
                <div>
                  I agree to the
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="https://www.greengeeks.com/legal/atoc"
                        @click.stop
                        v-on="on"
                      >
                        Affiliate Terms of Service
                      </a>
                    </template>
                    Opens in new tab
                  </v-tooltip>
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-col>
        <v-col cols="12" class="text-center">
          <gg-btn x-large @click="join" :loading="loading">Join Now</gg-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import amapi from '@/api/amapi'

export default {
  name: 'NewAffiliatesAccount',
  data () {
    return {
      agreement: false,
      loading: false,
      model: {
        describes: '',
        paypal_address: ''
      },
      items: [
        'Instructor/Education',
        'Blogger',
        'Web Designer/Web Developer',
        'Marketing Agency',
        'Coupon/Deals Website',
        'Shopping/Hosting Comparison',
        'Search Engine Marketing',
        'Other'
      ],
      rules: {
        describes: {
          required: true,
        },
        paypal_address: {
          required: true,
          email: true
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      canCreateProfile: 'affiliates/canCreateProfile'
    }),
  },
  methods: {
    ...mapActions(['reportError']),
    async join () {
      const valid = await this.$validator.validateAll()
      if (!valid) { return false }
      this.loading = true
      try {
        await amapi.makecall('aff_create', {
          classification: this.model.describes,
          paypal_address: this.model.paypal_address
        })
        this.$router.push({ name: 'affiliates' })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.canCreateProfile) {
        this.$router.push({ name: 'affiliates' })
      }
    })
  }
}
</script>

<style scoped lang="scss">
.affiliates-account {
  background-color: #F7F9FC;
}
.list-unstyled li {
  padding: 4px 0;
}
</style>
